export const formTransform = data => {
    const { contractors } = data;

    if (contractors && Array.isArray(contractors)) {
        const validContractors = contractors.filter(contractor => contractor?.id !== undefined);
        data.contractorIds = validContractors?.map(object => object?.id);
        data.contractorCollectionPointIds = validContractors?.reduce((acc, contractor) => {
            acc[contractor?.id] = contractor?.collectionPointIds;
            return acc;
        }, {});
        delete data.contractors;
    }

    return data;
};
